import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  CurrencyInput as DesignSystemCurrencyInput,
} from '@wegroup/design-system';
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { handleResponseLanguage } from '../../../../../../../../../../i18n';
import { CalculationSpec } from '../../../../../../../../../../types/Quotes';

interface Props {
  calculationSpec: CalculationSpec;
}

const CurrencyInput: React.FC<Props> = ({ calculationSpec }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Controller
      name={calculationSpec.calc_type}
      control={control}
      render={({
        field: { onChange, ...fieldProps },
        fieldState: { error },
      }) => (
        <FormControl isInvalid={!!error}>
          <FormLabel>{handleResponseLanguage(calculationSpec.title)}</FormLabel>
          <DesignSystemCurrencyInput
            placeholder="0,00"
            onChange={({ value }) => onChange(value)}
            {...fieldProps}
            isDisabled={
              calculationSpec.disabled || !calculationSpec.specs_field
            }
            min={0}
          />
          {error?.message && (
            <FormErrorMessage>{t(error.message)}</FormErrorMessage>
          )}
        </FormControl>
      )}
    />
  );
};

export default CurrencyInput;
